import { useState } from 'react';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'; // Importa le icone hamburger e close


export default function NavBar() {

  const [menuOpen, setMenuOpen] = useState(false); // Stahref per gestire il menù a tendina

  const routes = [
    { href: "/", label: "Home" },
    { href: "/chi-siamo", label: "Chi siamo" },
    { href: "/regole-3p", label: "Le regole delle 3P" },
    { href: "/prodotti", label: "Prodotti" },
    // { href: "/recensioni", label: "Recensioni" },
    { href: "/richiedi-preventivo", label: "Richiedi preventivo" },
    { href: "/contatti", label: "Contatti" }
    

  ];

  const hrefggleMenu = () => {
    setMenuOpen(!menuOpen); // hrefggle per aprire o chiudere il menù
  };


  return (
    <nav className="w-full p-8 max-w-[2000px] mx-auto">
      <div className="flex items-center justify-between lg:justify-start w-full  ">
        {/* Logo */}
        <a href="/">
          <img src="/DOTSerramenti_logo.png" alt="Logo" className="w-20 h-20" />
        </a>

        {/* Menu Icon for small screens */}
        <div className="lg:hidden ">
          <button onClick={hrefggleMenu} className="text-3xl focus:outline-none">
            {menuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
          </button>
        </div>

        {/* as - Hidden on small screens, visible on large screens */}
        <div className="hidden lg:flex justify-between w-full lg:px-20 xl:px-48 ">
          {routes.map((route) => {
            if (route.href === "/prodotti") {
              return (
                <a
                  key={route.href}
                  href={route.href}
                  className="relative p-1 text-base font-medium text-secondary-color transition-colors duration-300 ease-in-out after:absolute 
        after:bottom-0 after:left-0 after:w-0 after:h-1 after:bg-logo-color after:content-[''] after:transition-all 
        after:duration-300 after:ease-in-out hover:after:w-full"
                >
                  {route.label}
                </a>
              );
        //       return (
        //         <Popover key={route.href} className="relative p-1 text-base font-medium text-secondary-color transition-colors duration-300 ease-in-out after:absolute 
        // after:bothrefm-0 after:left-0 after:w-0 after:h-1 after:bg-logo-color after:content-[''] after:transition-all 
        // after:duration-300 after:ease-in-out hover:after:w-full">
        //           {({ close }) => ( // Ottieni la funzione `close` dal render props
        //             <>
        //               <PopoverButhrefn className="hover:text-gray-600">
        //                 {route.label}
        //               </PopoverButhrefn>

        //               {/* Il popover menu */}
        //               <PopoverPanel className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
        //                 <ul className="py-2" onClick={() => close()}>
        //                   <li>
        //                     <a
        //                       href="/prodotti"
        //                       className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
        //                     >
        //                       Tutti i prodotti
        //                     </a>
        //                   </li>
        //                   <li>
        //                     <a
        //                       href="/serramenti"
        //                       className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
        //                     >
        //                       Serramenti
        //                     </a>
        //                   </li>
        //                   <li>
        //                     <a
        //                       href="/porte"
        //                       className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
        //                     >
        //                       Porte
        //                     </a>
        //                   </li>
        //                   <li>
        //                     <a
        //                       href="/finestre"
        //                       className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
        //                     >
        //                       Finestre
        //                     </a>
        //                   </li>
        //                   <li>
        //                     <a
        //                       href="/persiane"
        //                       className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
        //                     >
        //                       Persiane
        //                     </a>
        //                   </li>
        //                 </ul>
        //               </PopoverPanel>
        //             </>
        //           )}
        //         </Popover>


        //       );
            } else {
              return (
                <a
                  key={route.href}
                  href={route.href}
                  className="relative p-1 text-base font-medium text-secondary-color transition-colors duration-300 ease-in-out after:absolute 
        after:bothrefm-0 after:left-0 after:w-0 after:h-1 after:bg-logo-color after:content-[''] after:transition-all 
        after:duration-300 after:ease-in-out hover:after:w-full"
                >
                  {route.label}
                </a>
              );
            }
          })}

        </div>
        <a href="/" className='hidden lg:flex'>
          <img src="/DOTSerramenti_logo.png" alt="Logo" className="w-20 h-20" />
        </a>
      </div>
      
      {/* Dropdown Menu - Visible only on small screens when menuOpen is true */}
      {menuOpen && (
        <div className="lg:hidden flex flex-col space-y-4 mt-4 px-4 ">
          {routes.map((route) => (
            <a
              key={route.href}
              href={route.href}
              onClick={() => setMenuOpen(false)}
              className="relative p-1 text-center text-base font-medium text-secondary-color transition-colors duration-300 ease-in-out 
                        after:absolute after:bottom-0 after:left-0 after:w-0 after:h-1 after:bg-logo-color 
                        after:content-[''] after:transition-all after:duration-300 after:ease-in-out hover:after:w-full"
            >
              {route.label}
            </a>
          
          ))}
        </div>
      )}
    </nav>
  );
}
